import React, {memo, forwardRef} from 'react';
import {Text as RNText} from 'react-native';
import {createUseStyle} from "@redlink/assets/styles";

export const Text = memo(
    forwardRef(({style, en = false, ...restProps}, ref) => {
        const {styles} = useStyle();
        return (
            <RNText {...{ref}} {...restProps} style={[!en && styles.text, style]}/>
        );
    })
);

const useStyle = createUseStyle(({colors, ltrFlexDirection, language}) => ({
    text: {
        ...(language === 'fa' && {fontFamily: 'dana'}),
    },
}));
